import { MiddlewareAPI, Middleware } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { AppDispatch } from 'app/store';
import IInsuranceCase from 'app/models/Case';
import { IConversation, IConversationQuestion } from 'app/models/ChatAI';
// Async
import { createConversation } from 'app/store/AIChat/AIChat.async';
// Actions
import { AIChatActions } from 'app/store/AIChat/AIChat.slice';
// Selectors
import { selectInsuranceCase } from 'app/store/Cases/Cases.selectors';
//
import { selectCaseAIChatPrompts } from 'app/store/AIChatPrompts/AIChatPrompts.selectors';

let questionData:IConversationQuestion = {
  text: ''
};

const AIChatMiddleware:Middleware = ({ getState, dispatch }:MiddlewareAPI<AppDispatch>) => (next:any) => (action:any) => {
  const { type, payload } = action;

  if ( (type as string).startsWith(Reducers.AIChat) ){
    const state = getState()
    const insuranceCase = selectInsuranceCase(state) as IInsuranceCase;
    const prompts = selectCaseAIChatPrompts(state);

    if ( type === createConversation.pending.type ){
      const { question } = action.meta.arg;
      if ( !question ) return next(action);
      const { text, promptId, coverage } = question;
      // Since `conversation` is not yet created, we cannot set the conversation
      // So we set the temporary human message text to be used later
      // Lets check if we have a text or promptId)
      if ( promptId && prompts ){
        const prompt = prompts.find((p) => p.id === promptId);
        if ( !prompt ) return next(action);
        questionData.text = prompt.content;
      } else if ( text ){
        // If we have a text, we will use it as a human message text
        questionData.text = text;
      }
      if ( coverage ) questionData.coverage = coverage;
    } else if ( type === createConversation.fulfilled.type ){
      const conversation = payload as IConversation;

      dispatch(AIChatActions.setConversation({ conversation, question: questionData }));
      dispatch(AIChatActions.setSkipInitialChatFetch(true));

      dispatch(push(`/admin/cases/${insuranceCase.id}/ai-chat/${conversation.id}`));

      questionData = {
        text: ''
      };
    }
  }

  return next(action);
}

export default AIChatMiddleware;
